export function getdata() {
    return {
        headData: [
            {
                title: '实体',
                prop: 'entity'
            },
            {
                title: '核查',
                prop: 'verifiable'
            },
            {
                title: '调研',
                prop: 'survey'
            },
            {
                title: '稽查',
                prop: 'inspection'

            }
        ],
        headStatisticData: {
            preferentialPoliciesAmount: "0.00",
            preferentialPoliciesScale: "0%",
            taxAmount: "0",
            taxAmountScale: "0%",
            taxBurden: null,
            taxBurdenScale: null
        },
        pageHeadData: {
            declareCompleteCount: "0",
            declareCount: "0",
            paymentCompleteCount: "0",
            paymentCount: "0",
        }
    };
}
